/// <amd-module name="SuiteCommerce.TestimonialsCCT.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.TestimonialsCCT.Model", ["require", "exports", "Backbone", "SuiteCommerce.Testimonials.Utils", "SuiteCommerce.Testimonials.Testimonial.Collection", "SuiteCommerce.Testimonials.Testimonial.Model"], function (require, exports, Backbone_1, Utils_1, Testimonial_Collection_1, Testimonial_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CCTFields;
    (function (CCTFields) {
        CCTFields["header"] = "custrecord_ns_sc_ext_ct_headername";
        CCTFields["orientation"] = "custrecord_ns_sc_ext_ct_template";
        CCTFields["imageStyle"] = "custrecord_ns_sc_ext_ct_imagestyle";
        CCTFields["fontColor"] = "custrecord_ns_sc_ext_ct_fontcolor";
        CCTFields["linkOption"] = "custrecord_ns_sc_ext_ct_linkoption";
        CCTFields["openInNewWindow"] = "custrecord_ns_sc_ext_ct_newwindow";
        CCTFields["testimonialImage"] = "custrecord_ns_sc_ext_ct_image${key}";
        CCTFields["testimonialImageAlt"] = "custrecord_ns_sc_ext_ct_alttext${key}";
        CCTFields["testimonialBody"] = "custrecord_ns_sc_ext_ct_textbody${key}";
        CCTFields["testimonialTitle"] = "custrecord_ns_sc_ext_ct_title${key}";
        CCTFields["testimonialSubtitle"] = "custrecord_ns_sc_ext_ct_subtitle${key}";
        CCTFields["testimonialLink"] = "custrecord_ns_sc_ext_ct_link${key}";
    })(CCTFields = exports.CCTFields || (exports.CCTFields = {}));
    var TestimonialsCCTModel = /** @class */ (function (_super) {
        __extends(TestimonialsCCTModel, _super);
        function TestimonialsCCTModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.TESTIMONIALS_KEYS = ['1', '2', '3'];
            return _this;
        }
        Object.defineProperty(TestimonialsCCTModel.prototype, "header", {
            get: function () {
                return this.getSetting(CCTFields.header);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "orientation", {
            get: function () {
                return this.getSetting(CCTFields.orientation);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "imageStyle", {
            get: function () {
                return this.getSetting(CCTFields.imageStyle);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "fontColor", {
            get: function () {
                return this.getSetting(CCTFields.fontColor);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "linkOption", {
            get: function () {
                return this.getSetting(CCTFields.linkOption);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "openInNewWindow", {
            get: function () {
                return this.getSetting(CCTFields.openInNewWindow);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialsCCTModel.prototype, "testimonials", {
            get: function () {
                if (!this.get('testimonials')) {
                    this.testimonials = new Testimonial_Collection_1.TestimonialCollection();
                }
                return this.get('testimonials');
            },
            set: function (testimonials) {
                this.set('testimonials', testimonials);
            },
            enumerable: true,
            configurable: true
        });
        TestimonialsCCTModel.prototype.addProperties = function (properties) {
            this.set(properties);
            this.updateTestimonialsList();
        };
        TestimonialsCCTModel.prototype.updateTestimonialsList = function () {
            var _this = this;
            var notEmptyTestimonials = [];
            this.TESTIMONIALS_KEYS.forEach(function (key) {
                var testimonial = new Testimonial_Model_1.TestimonialModel({
                    id: key,
                    altText: _this.getSetting(CCTFields.testimonialImageAlt, key),
                    imageURL: _this.getImageUrl(CCTFields.testimonialImage, key),
                    link: _this.getSetting(CCTFields.testimonialLink, key),
                    subTitle: _this.getSetting(CCTFields.testimonialSubtitle, key),
                    textBody: _this.getSetting(CCTFields.testimonialBody, key),
                    title: _this.getSetting(CCTFields.testimonialTitle, key),
                });
                if (!testimonial.isEmpty()) {
                    notEmptyTestimonials.push(testimonial);
                }
            });
            this.testimonials.reset(notEmptyTestimonials);
        };
        TestimonialsCCTModel.prototype.getImageUrl = function (field, key) {
            var imageId = this.getSetting(field, key);
            var fieldId = this.replaceKeyInField(field, key);
            return imageId &&
                this.get(fieldId + "_url") &&
                this.get(fieldId + "_url").indexOf(imageId) !== -1
                ? this.get(fieldId + "_url")
                : '';
        };
        TestimonialsCCTModel.prototype.getSetting = function (field, key) {
            var fieldId = this.replaceKeyInField(field, key);
            return Utils_1.Utils.trim(this.get(fieldId));
        };
        TestimonialsCCTModel.prototype.replaceKeyInField = function (field, replacement) {
            return replacement ? field.replace('${key}', replacement) : field;
        };
        return TestimonialsCCTModel;
    }(Backbone_1.Model));
    exports.TestimonialsCCTModel = TestimonialsCCTModel;
});
